import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setBooking(data); setStatus("paid"); return; }
        if (tries++ < 6) setTimeout(poll, 2000); else setStatus("pending");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#0F2537] text-[#F6F4F0] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}
        data-testid="payment-success" className="max-w-lg text-center">
        {status === "checking" && (
          <><Loader2 className="w-10 h-10 animate-spin mx-auto mb-6 text-[#B86B52]" />
          <p className="font-light text-[#A3A09A]">Confirming your reservation…</p></>
        )}
        {status === "paid" && (
          <>
            <div className="w-20 h-20 rounded-full bg-[#B86B52] flex items-center justify-center mx-auto mb-8">
              <Check className="w-10 h-10 text-white" strokeWidth={2} />
            </div>
            <span className="overline text-[#B86B52]">Reservation Confirmed</span>
            <h1 className="font-display font-light text-5xl mt-6 mb-4">Gracias, {booking?.guest_name?.split(" ")[0]}!</h1>
            <p className="text-[#A3A09A] font-light leading-relaxed">
              Punto Nima is reserved for {booking?.check_in} → {booking?.check_out}. A confirmation has been sent to the owner
              and you'll receive arrival details shortly. Total paid: <span className="text-[#F6F4F0]">${booking?.amount}</span>.
            </p>
          </>
        )}
        {(status === "pending" || status === "error") && (
          <>
            <h1 className="font-display font-light text-4xl mb-4">Almost there</h1>
            <p className="text-[#A3A09A] font-light">Your payment is being processed. If you were charged, your booking is secure — please check your email or contact the owner.</p>
          </>
        )}
        <Link to="/" data-testid="back-home" className="inline-block mt-10 px-8 py-3.5 bg-[#F6F4F0] text-[#0F2537] rounded-sm tracking-wide hover:bg-white transition-colors">
          Back to Home
        </Link>
      </motion.div>
    </div>
  );
}
